import { render, staticRenderFns } from "./MessagesBox.vue?vue&type=template&id=bf3b2aae&"
import script from "./MessagesBox.vue?vue&type=script&lang=js&"
export * from "./MessagesBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports